import React, { useEffect, useMemo, useState } from 'react';
import { useTable } from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CampaignsType.css';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { CampaignTypeService } from '../../../../Services/Axios/Api';
import { toast } from 'react-toastify';

const CampaignsType = () => {
    const [campaignData, setCampaignData] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await CampaignTypeService.getCampaignTypes();
        setCampaignData(response.result);
    };

    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const columns = useMemo(
        () => [
            {
                Header: 'Type Name',
                accessor: 'name',
            },
            {
                Header: 'Type Mode',
                accessor: 'mode',
            },
            {
                Header: 'Actions',
                Cell: ({ row }) => (
                    <div className="action-buttons">
                        <button className="btn btn-outline-primary btn-sm me-2" onClick={() => navigate(`edit/${row.original.id}`)}><FontAwesomeIcon icon={faEdit} /></button>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => openDeleteModal(row.original.id)}><FontAwesomeIcon icon={faTrash} /></button>
                    </div>
                ),
            },
        ],
        []
    );

    const openDeleteModal = (id) => {
        setSelectedId(id);
        setShowModal(true);
    };

    const handleDelete = async () => {
        try {
            await CampaignTypeService.deleteCampaignType(selectedId);
            setShowModal(false);
            toast.success('Campaign type deleted successfully');
            fetchData();
        } catch (error) {
            toast.error('Failed to delete campaign type');
            console.error('Error deleting campaign type:', error);
        }
    };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: campaignData });
    const navigate = useNavigate();
    return (
        <div className="container mt-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Campaign Types</h2>
                <button className="btn btn-success" onClick={() => navigate('add')}>Add New</button>
            </div>
            <div className="table-responsive">
                <table className="table table-hover" {...getTableProps()}>
                    <thead className="thead-light">
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()} >
                                    {row.cells.map(cell => (
                                        <td {...cell.getCellProps()} key={cell.column.id}>{cell.render('Cell')}</td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this campaign type?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CampaignsType;
